/* eslint-disable react/display-name */
import { FC, PropsWithChildren } from 'react';

export const createComposableProvider =
	<TComponentProps extends object>(Provider: FC<PropsWithChildren>) =>
	(Component: FC<TComponentProps>) =>
	(componentProps: TComponentProps) => (
		<Provider>
			<Component {...componentProps} />
		</Provider>
	);
